import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Text, ThemeProvider, TaktIdProvider } from '@amzn/storm-ui-v3';
import { Provider } from 'react-redux';
import { UnifiedReportCenterRoutes } from './unified-report-center-routes';
import AppInitWrapper from './components/AppInitWrapper';
import store from './store/store';
import './services/i18n';
import '@urc-ui/services/logger/katalLogger';
import { reportMetadataApi } from '@urc-ui/store/api/report-metadata/reportMetadata';
import { addQueryParams, isADSPReportCenterEnabled, isUiRossCutoverEnabled } from '@urc-ui/utils/app-utils';
import { advertiserInfoApi, buildGetAdvertiserInfoRequest } from '@urc-ui/store/api/advertisers/advertisers';
import { buildGetSubscriptionsRequest, subscriptionsApi } from '@urc-ui/store/api/subscriptions/subscriptions';
import { DEFAULT_PAGE_OFFSET, DEFAULT_PAGE_SIZE } from '@urc-ui/store/constants';
import { buildListSubscriptionsRequest } from '@urc-ui/store/api/ross/transformers/sspa-to-ross-transformers';
import { rossSubscriptionsApi } from '@urc-ui/store/api/ross/subscriptions/subscriptions';

// Fetch report metadata asynchronously outside App.
store.dispatch(reportMetadataApi.endpoints.getReportMetadata.initiate());

// Fetch subscriptions asynchronously outside App.
if (isUiRossCutoverEnabled()) {
  const listSubscriptionsRequest = buildListSubscriptionsRequest(DEFAULT_PAGE_SIZE);
  store.dispatch(rossSubscriptionsApi.endpoints.listSubscriptions.initiate(listSubscriptionsRequest));
} else {
  const getSubscriptionsRequest = buildGetSubscriptionsRequest(DEFAULT_PAGE_SIZE, DEFAULT_PAGE_OFFSET);
  store.dispatch(subscriptionsApi.endpoints.getSubscriptions.initiate(getSubscriptionsRequest));
}

// Fetch advertiser info asynchronously outside App.
if (isADSPReportCenterEnabled()) {
  store.dispatch(advertiserInfoApi.endpoints.getAdvertiserInfo.initiate(buildGetAdvertiserInfoRequest()));
}

addQueryParams();

const taktId = 'unified-report-center';
const root = createRoot(document.getElementById('advertising-reports') as HTMLElement);
const router = createBrowserRouter(UnifiedReportCenterRoutes, { basename: '/reports' });

root.render(
  <React.StrictMode>
    <AppInitWrapper>
      <TaktIdProvider taktId={taktId}>
        <ThemeProvider>
          <Provider store={store}>
            {/* The Suspense component causes React to display the fallback KatSpinner until
                the i18n translation strings have been loaded. */}
            <React.Suspense fallback={<Text>Loading...</Text>}>
              <RouterProvider router={router} />
            </React.Suspense>
          </Provider>
        </ThemeProvider>
      </TaktIdProvider>
    </AppInitWrapper>
  </React.StrictMode>
);
